import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { useSuspenseQueries } from '@tanstack/react-query'
import { useConfig } from 'wagmi'

import {
  StusdsRiskParameters,
  stusdsRiskParametersQueryFunction,
  stusdsRiskParametersQueryKey,
} from '../../common/logic/stusdsRiskParameters'
import {
  stusdsWithdrawDataQueryFunction,
  stusdsWithdrawDataQueryKey,
} from '../../withdraw/logic/stusds/stusdsWithdrawDataQuery'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { useSavingsTokenRepository } from '@/features/savings/common/useSavingsTokenRepository'

export interface UseStusdsWelcomeDialogParams {
  chainId: number
}

export interface UseStusdsWelcomeDialogResul extends StusdsRiskParameters {
  usds: Token
  totalAssets: NormalizedNumber
  lockstakeDebt: NormalizedNumber
}

export function useStusdsWelcomeDialog({ chainId }: UseStusdsWelcomeDialogParams): UseStusdsWelcomeDialogResul {
  const wagmiConfig = useConfig()
  const { account } = useConnectedAddress({ throwOnNotConnected: false })

  const tokenRepository = useSavingsTokenRepository({ chainId, account })
  const usds = tokenRepository.findOneBySymbol(TokenSymbol('USDS'))

  const [{ data: stusdsRiskParameters }, { data: stusdsWithdrawData }] = useSuspenseQueries({
    queries: [
      {
        queryKey: stusdsRiskParametersQueryKey({ chainId }),
        queryFn: () => stusdsRiskParametersQueryFunction({ wagmiConfig, chainId }),
      },
      {
        queryKey: stusdsWithdrawDataQueryKey({ chainId }),
        queryFn: () => stusdsWithdrawDataQueryFunction({ wagmiConfig, chainId }),
      },
    ],
  })

  const totalAssets = stusdsWithdrawData.totalAssets
  const lockstakeDebt = stusdsWithdrawData.lockstakeDebt

  return {
    ...stusdsRiskParameters,
    usds,
    totalAssets,
    lockstakeDebt,
  }
}
